var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container-query',{attrs:{"query":_vm.query},model:{value:(_vm.screen),callback:function ($$v) {_vm.screen=$$v},expression:"screen"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }